import { ITagsSchema } from './tags-schema.interface';

export interface ICarrierSchema {
    id: string;
    organizationId?: string | null;
    name: string;
    externalId?: string | null;
    code: string;
    address?: string | null;
    vatNumber?: string;
    influenceZone?: string | null;
    locations?: string[];
    tags?: string[] | ITagsSchema[] | null;
    businessName: string;
    phoneNumber?: string;
    email?: string;
    country?: string;
}
